import React from 'react';
import QuestionLabel from './QuestionLabel';
import { FormPart, part } from '~/lib/FormCssApi';

const TextQuestion = ({ label, value, setValue, settings }) => {
    const type = settings?.numeric ? 'number' : 'text';

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <input
                    {...part(FormPart.INPUT)}
                    type={type}
                    min={settings?.min}
                    max={settings?.max}
                    value={value || ''}
                    onChange={e => setValue(e.target.value)}
                />
            </div>
        </label>
    );
};

export default TextQuestion;
